<template>
    <div id="blog-page">
        <!-- AD -->
        <div v-if="currentBlogTopAd" v-on:click="handleAdClick(currentBlogTopAd)" class="header-banner">
            <img :src="currentBlogTopAd.imageBanner | optimizeBanner" alt="">
        </div>
        <div v-if="currentBlogTopAd" v-on:click="handleAdClick(currentBlogTopAd)" class="header-banner-mobile">
            <img :src="currentBlogTopAd.imageBannerMobile | optimizeBanner" alt="">
        </div>
        <!-- AD END -->
        <div v-if="!blogs">Loading</div>
        <div v-else>
            <div class="blog-posts-title"><p>Greinar</p></div>
            <div class="blog-posts-wrap">
                
                <div v-for="thisBlog in sortBlogs(blogs)" :key="thisBlog.id" class="blog-post-preview">
                    <router-link :to="{ name: 'blog-post', params: {postID: thisBlog.id} }">
                        <div class="blog-post-preview-image">
                            <img :src="thisBlog.image | optimizeBlog" alt="">
                        </div>
                        <div class="blog-post-preview-title">
                            <p>{{ thisBlog.title }}</p>
                        </div>
                        <!-- <div v-html="thisBlog.body" id="blog-post-preview-body" class="blog-post-preview-body"></div> -->
                        <!--<div class="blog-post-preview-footer">
                             <div class="blog-post-preview-footer-date">{{ displayDate(thisBlog.datepublished) }}</div>
                        </div> -->
                    </router-link>
                </div>
            </div>
        </div>
        <!-- AD -->
        <!-- <div class="footer-banner">
            <img src="https://via.placeholder.com/1150x141/b33b3b" alt="">
        </div>
        <div class="footer-banner-mobile">
            <img src="https://via.placeholder.com/354x98/b33b3b" alt="">
        </div> -->
        <!-- AD END -->
    </div>
</template>

<script> 
import { mapState } from 'vuex'
import moment from 'moment'
const fb = require('../firebaseConfig.js')

export default {
    data() {
        return {

        }
    },
    computed: {
        ...mapState(["blogs", 'currentBlogTopAd'])
    },
    methods: {
        sortBlogs() {
            // Sorts blogs by date and only displays blogs that are published
            var sortedBlogs = []
            var now = new Date()
            var copyBlogs = this.blogs.slice()
            copyBlogs.sort(function(a,b){return Date.parse(b.datepublished) - Date.parse(a.datepublished)})
            for (let index = 0; index < copyBlogs.length; index++) {
                if (Date.parse(copyBlogs[index].datepublished) < now) {
                    if (copyBlogs[index].visibility == 1) {
                        sortedBlogs.push(copyBlogs[index])
                    }
                }
            }
            return sortedBlogs
        },
        displayDate: function(timestamp) {
            if (timestamp) {
                timestamp = new Date(timestamp)
            return moment(timestamp).format('DD/MM/YYYY')
            } else {
                return "DD/MM/YYYY"
            }
            
        },
        handleAdClick(ad) {
            window.open(ad.url)
            fb.db.collection("ads").doc(ad.id).update({
                clicks: ad.clicks + 1,
            })
        }
    },
    mounted: function() {
        
    },
    filters: {
        optimizeBlog: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto,h_1050/')
            return newUrl
        },
        optimizeBanner: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto/')
            return newUrl
        }
    }
}
</script>

<style>
@media only screen and (max-width: 768px) {
    .blog-posts-title {
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .blog-posts-title p {
        margin:0;
    }
    .blog-post-preview {
        width:352px;
        /*height:353px;*/
    }
}

@media only screen and (min-width: 769px) {
    .blog-post-preview {
        width:352px; /* 450px */
        /*height:310px; */ /* 353px */
        margin-left: 10px; 
        margin-right: 10px;
    }
}

@media only screen and (min-width: 1200px) {

}

.blog-page {
    width:100%;
}
.blog-posts-title {
    font-size: 32px;
    color: #b33b3b;
}
.blog-posts-wrap {
    width: 100%;
    display:flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 30px;
}
.blog-post-preview {
    position: relative;
    margin-bottom: 30px;
    box-shadow: 0 1px 6px #8f8c8b;
    background-color: white;
    cursor:pointer;
}
.blog-post-preview-image {
    /* height: 198px; */ /* 253 */
    width:100%;
    overflow: hidden;
    background-color: white;
}
.blog-post-preview-image img {
    max-width:100%;
    height:auto;
}
.blog-post-preview-title p{
    margin-top: 5px;
    margin-bottom: 5px;
    font-size: 26px;
}
.blog-post-preview-body {
    margin-top: 0px;
    margin: 0 auto;
    width:90%;
    height:120px;
    text-align: justify;
    overflow: hidden;
}
.blog-post-preview-footer {
    position: absolute;
    margin:0;
    color: #d17076;
    margin-top: 5px;
    right:0;
    bottom:0;
    margin-bottom: 10px;
    margin-right: 20px;
}

</style>